import { downloadBlob } from '../documents/downloadBlob';
import { csvEscape, toDate, sortRecordsNewestFirst } from '../../utils/analyticsShared';
export function showAppToast(message, type = 'info', soundEffects = {}) {
  try {
    if (type === 'success') {
      soundEffects.playSuccess && soundEffects.playSuccess();
    } else if (type === 'error') {
      soundEffects.playError && soundEffects.playError();
    } else if (type === 'warning') {
      soundEffects.playWarning && soundEffects.playWarning();
    } else if (type === 'info') {
      soundEffects.playInfo && soundEffects.playInfo();
    } else {
      soundEffects.playNotify && soundEffects.playNotify();
    }
  } catch {
    void 0;
  }

  import('../../assets/Toast').then(({ addToast }) => {
    addToast(message, type);
  });
}

export function exportMeldingenCsv(filteredMeldingen = []) {
  const csvContent = [
    ['Datum', 'Robot', 'Gemeente', 'K-Nummer', 'Onderdelen', 'Uren', 'Mesjes', 'Bezocht', 'Normaal', 'Koppen', 'MesjesPerKop', 'TotaleMesjescapaciteit', 'Technicus'].join(','),
    ...sortRecordsNewestFirst(filteredMeldingen).map((melding) => [
      toDate(melding.timestamp ?? melding.createdAt)?.toLocaleString('nl-NL') || '',
      melding.naam || '',
      melding.gemeente || '',
      melding.kNummer || '',
      melding.onderdelen || '',
      melding.uren || 0,
      melding.mesjes || 0,
      (typeof melding.isRobotBezocht === 'boolean' ? melding.isRobotBezocht : String(melding.robotBezocht ?? 'Ja').toLowerCase() !== 'nee') ? 'Ja' : 'Nee',
      (typeof melding.isNormaleMelding === 'boolean' ? melding.isNormaleMelding : String(melding.meldingNormaal ?? 'Ja').toLowerCase() !== 'nee') ? 'Ja' : 'Nee',
      Math.max(0, Number(melding.bladeHeads ?? melding.robotBladeConfig?.bladeHeads ?? 0)) || 0,
      Math.max(0, Number(melding.bladesPerHead ?? melding.robotBladeConfig?.bladesPerHead ?? 0)) || 0,
      Math.max(0, Number(melding.totalBlades ?? melding.robotBladeConfig?.totalBlades ?? 0)) || 0,
      melding.displayName || '',
    ].map(csvEscape).join(',')),
  ].join('\n');

  const blob = new Blob(['\ufeff', csvContent], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, `meldingen_export_${new Date().toISOString().split('T')[0]}.csv`);
}
